import { render, staticRenderFns } from "./Actionbar.vue?vue&type=template&id=25bf51f5&"
import script from "./Actionbar.vue?vue&type=script&lang=js&"
export * from "./Actionbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports